import { useEffect, useState } from "react"
import {
  StoryblokComponent,
  useStoryblokState,
  getStoryblokApi,
  ISbStoryData,
} from "@storyblok/react"

function ConciergePage() {
  const [story, setStory] = useState<ISbStoryData | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      const sbApi = getStoryblokApi()
      try {
        const { data } = await sbApi.get(`cdn/stories/concierge`, {
          version: "draft",
        })
        setStory(data?.story)
      } catch (error) {
        console.error("Failed to load concierge page:", error)
      }
    }

    fetchData()
  }, [])

  const liveStory = useStoryblokState(story as ISbStoryData)

  if (!liveStory || !liveStory.content) return null

  return (
    <>
      <StoryblokComponent blok={liveStory.content} />
    </>
  )
}

export default ConciergePage
